function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
export default (function (_ref) {
  var colors = _ref.colors,
    mediaQueries = _ref.mediaQueries;
  return {
    base: _defineProperty({
      display: 'none',
      float: 'left',
      height: '100%',
      alignItems: 'center',
      fill: colors.secondary,
      cursor: 'pointer'
    }, mediaQueries.breakpointTablet, {
      display: 'flex'
    }),
    icon: {
      width: '20px',
      height: '20px',
      fill: colors.secondary
    }
  };
});